import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import PrivacyPolicyPage from '@/pages/privacy-policy/page';
import SnsManagementPage from '@/pages/services/sns-management/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/services/sns-management',
    element: <SnsManagementPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
